export default function provisioningReducer(provisioning, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "sippeer":
      return { ...provisioning, sippeer: action.user ?? null };
    case "flexDesk":
      return { ...provisioning, [action.type]: action.value, sippeer: action.value ? null : provisioning.sippeer };
    case "vlanConfig":
    case "firmwareConfig":
      return { ...provisioning, ...action.value };

    case "addHandset":
      return {
        ...provisioning,
        accounts: [
          ...provisioning.accounts,
          {
            sippeer: action.sippeer,
            handset: action.handset,
            id: action.id,
          },
        ],
      };
    case "removeHandset": {
      return {
        ...provisioning,
        accounts: provisioning.accounts.filter((_account) => _account.id !== action.id),
      };
    }

    default:
      return { ...provisioning, [action.type]: action.value };
  }
}
